angular.module('rjmNg.directives').directive "routeToClass", [
  "$location"
  ($location) ->
    restrict: "A"
    scope: false
    link: (scope, elm, attrs) ->
      numberPattern = new RegExp(/\/\d+$/)
      currentClass = ""
      defaultRouteText = "home"
      scope.$on "$routeChangeSuccess", ($event, current, previous) ->
        elm.removeClass currentClass
        if numberPattern.test $location.path()
          elm.addClass attrs.routeToClass || defaultRouteText
          currentClass = attrs.routeToClass || defaultRouteText
        else
          words = $location.path().match(/\w+/g)
          if words
            elm.addClass words.join("_")
            currentClass = words.join("_")
          else
            currentClass = ""
]
